import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import type { FileRouteContext } from '@jotta/types/schemas/FileRouteSchema'
import * as Dropdown from '@radix-ui/react-dropdown-menu'
import { FileApiPathNavLink } from '../FileRouteLink/FileApiPathLink'
import styles from './FileBreadCrumb.module.scss'
import { FileBreadCrumbItem } from './FileBreadCrumbItem'
import SvgCaretRight from '@jotta/ui/SvgCaretRight'
import SvgBoldMoreHorisontal from '@jotta/ui/SvgBoldMoreHorisontal'

export interface EllipsisProps {
  context: FileRouteContext
  items: {
    path: string
    name: string
  }[]
}

export function FileBreadCrumbEllipsis({ items, context }: EllipsisProps) {
  if (!items.length) {
    return null
  }

  return (
    <FileBreadCrumbItem hide="small">
      <Dropdown.Root>
        <Dropdown.Trigger>
          <PlainBrandIcon
            icon={SvgBoldMoreHorisontal}
            className={styles.more}
          />
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content className={styles.dropdown}>
            {items.map((item, i) => (
              <Dropdown.Item key={`breadcrumbRoot-${item.path}${i}`} asChild>
                <FileApiPathNavLink end path={item.path}>
                  {item.name}
                </FileApiPathNavLink>
              </Dropdown.Item>
            ))}
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      <PlainBrandIcon icon={SvgCaretRight} className={styles.separator} />
    </FileBreadCrumbItem>
  )
}
